import Splide from '@splidejs/splide';
import { EventInterface } from '@splidejs/splide';

const slidersArray = document.querySelectorAll('.js-cardsWithTextSlider');

// Using a custom transition, to apply the `is-visible` class to the next visible slides before transition
// And to provide a smoother transition
// Modified from: https://splidejs.com/guides/transition/
function updateVisibilityAndCustomizeTransition(Splide, Components) {
  const { bind } = EventInterface(Splide);
  const { Move } = Components;
  const { list, slides } = Components.Elements;

  let endCallback;
  let isTransitioning = false; // Flag to track transition state

  function mount() {
    // console.log('Custom transition mounted');

    // Bind to 'transitionend' event to finalize transition
    bind(list, 'transitionend', (e) => {
      if (e.target === list && endCallback) {
        // console.log('Transition ended');
        cancel();
        endCallback();
        endCallback = null; // Clear the callback to prevent duplicate calls
        isTransitioning = false; // Mark transition as complete
      }
    });

    // Ensure visibility updates on resize
    Splide.on('resize', () => {
      // console.log('Window resized');
      if (!isTransitioning) {
        updateVisibleSlides(Splide.index); // Recalculate visibility if no transition is in progress
      }
    });

    // Update visibility on initial mount
    updateVisibleSlides(Splide.index);
  }

  function start(index, done) {
    // console.log(`Starting transition to index ${index}`);

    // Prevent transitioning while another transition is in progress
    if (isTransitioning) return;

    // Ensure visibility is updated before transitioning
    updateVisibleSlides(index);

    // Mark the transition as in progress
    isTransitioning = true;

    const destination = Move.toPosition(index, true);
    const transitionDuration = 500; // Match the CSS transition time

    // Apply the CSS transition
    list.style.transition = `transform ${transitionDuration}ms cubic-bezier(.44,.65,.07,1.01)`;
    Move.translate(destination);

    // Keep the `done` callback for later
    endCallback = done;

    // Fallback for `transitionend` in case it doesn't fire
    setTimeout(() => {
      if (endCallback) {
        // console.warn('Fallback: Transition end callback invoked');
        endCallback();
        endCallback = null; // Clear the callback
        isTransitioning = false; // Ensure transition is marked as complete
      }
    }, transitionDuration + 50); // Add a small buffer
  }

  function cancel() {
    // console.log('Transition canceled');
    list.style.transition = ''; // Remove transition styles
  }

  // Function to update the `is-visible` class for the correct slides
  function updateVisibleSlides(index) {
    const perPage = Splide.options.perPage;

    // Clear existing `is-visible` classes
    slides.forEach(slide => slide.classList.remove('is-visible'));

    // Add `is-visible` class to the next visible slides
    for (let i = 0; i < perPage; i++) {
      const visibleIndex = (index + i) % slides.length;
      slides[visibleIndex].classList.add('is-visible');
    }
  }

  return {
    mount,
    start,
    cancel,
  };
}

document.addEventListener('DOMContentLoaded', () => {
  const slidersArray = document.querySelectorAll('.js-cardsWithTextSlider');

  slidersArray.forEach(slider => {
    const splide = new Splide(slider, {
      perPage: 1,
      perMove: 1,
      mediaQuery: 'min',
      pagination: false,
      breakpoints: {
        576: {
          perPage: 2,
        },
        1024: {
          perPage: 3,
        },
      },
    });

    // Mount Splide with custom transition logic
    splide.mount({}, updateVisibilityAndCustomizeTransition);
  });
});
